import { handleOptionChange, processDetails } from "@helpers/datagrid";
import DataGrid from "@shared/DataGrid";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Dimmer, Grid, Loader } from "semantic-ui-react";

const SimpleTab = (props) => {
  const { collectionId } = props.collection;
  const { onLoad } = props;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    summary: { headerDef: [], rowDef: [], data: [] },
    grid: { headerDef: [], rowDef: [], data: [] },
  });

  const { summary, grid } = data;

  const loadData = () => {
    if (!collectionId) return;
    setLoading(true);
    onLoad(collectionId, summary ? processDetails(summary.data) : {}).then(
      (response) => {
        setData(response);
        setLoading(false);
      },
      () => setLoading(false),
    );
  };

  useEffect(loadData, [onLoad, summary, collectionId]);

  const onOptionChange = (key, option, value) => {
    const newGrid = handleOptionChange(data[key], option, value);
    loadData();
    setData({ ...data, [key]: newGrid });
  };

  if (loading) {
    return (
      <Dimmer inverted active>
        <Loader active />
      </Dimmer>
    );
  }

  return (
    <Grid className="flex-stretch gs-flex-container-vertical h-100">
      {summary && summary.data && summary.data.length > 0 && (
        <Grid.Row>
          <Grid.Column>
            <DataGrid
              headings={summary.headerDef}
              data={summary.data}
              rowDef={summary.rowDef}
              fullHeight
              stretched
              onOptionChange={(option, value) =>
                onOptionChange("summary", option, value)
              }
            />
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row className="flex-stretch">
        <Grid.Column className="gs-flex-container-vertical">
          <DataGrid
            headings={grid.headerDef}
            data={grid.data}
            rowDef={grid.rowDef}
            onRowClick={() => {}}
            fullHeight
            stretched
            onOptionChange={(option, value) =>
              onOptionChange("grid", option, value)
            }
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    collection: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps)(SimpleTab);
